import { render, staticRenderFns } from "./SocialRewardsEmptyState.vue?vue&type=template&id=40c07e5e&scoped=true&"
import script from "./SocialRewardsEmptyState.vue?vue&type=script&lang=ts&"
export * from "./SocialRewardsEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewardsEmptyState.vue?vue&type=style&index=0&id=40c07e5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c07e5e",
  null
  
)

export default component.exports